"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dexie_1 = require("dexie");
const DEFAULT_DATABASE_NAME = "chats";
class ChatsDatabase extends dexie_1.default {
    constructor(prefix) {
        super(prefix ? `${prefix}-${DEFAULT_DATABASE_NAME}` : DEFAULT_DATABASE_NAME);
        const db = this;
        db.version(1).stores({
            chats: 'id, tempId, name, tags',
            chatMessages: 'id, timestamp, belongToChatId',
            chatMessageAttachments: 'id',
        });
    }
}
exports.ChatsDatabase = ChatsDatabase;
//# sourceMappingURL=ChatsDatabase.js.map